import { styled } from '../../Utilities';
import { ImageBase } from './Image.base';
import { getStyles } from './Image.styles';
export var Image = styled(ImageBase, getStyles, undefined, {
  scope: 'Image'
}, true);
Image.displayName = 'Image';